// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonStyles_pageContainer__oPCAy {
  min-height: 100vh;
  background-color: #f9f9f9;
  padding: 140px 20px 20px;
  position: relative;
}

.CommonStyles_backButton__cexXL {
  position: fixed;
  top: 80px;
  left: 20px;
  z-index: 100;
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.5rem;
  background-color: white;
  color: rgb(151, 1, 14);
  border: 2px solid rgb(151, 1, 14);
  border-radius: 8px;
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.CommonStyles_backButton__cexXL:hover {
  background-color: rgb(151, 1, 14);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.CommonStyles_contentContainer__-wR5E {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.CommonStyles_content__IOw17 {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .CommonStyles_pageContainer__oPCAy {
    padding: 140px 10px 20px;
  }

  .CommonStyles_backButton__cexXL {
    position: fixed;
    top: 70px;
    left: 10px;
    font-size: 1rem;
    padding: 0.6rem 1rem;
  }

  .CommonStyles_contentContainer__-wR5E {
    padding: 1rem;
  }

  .CommonStyles_content__IOw17 {
    padding: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/common/CommonStyles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".pageContainer {\r\n  min-height: 100vh;\r\n  background-color: #f9f9f9;\r\n  padding: 140px 20px 20px;\r\n  position: relative;\r\n}\r\n\r\n.backButton {\r\n  position: fixed;\r\n  top: 80px;\r\n  left: 20px;\r\n  z-index: 100;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.8rem 1.5rem;\r\n  background-color: white;\r\n  color: rgb(151, 1, 14);\r\n  border: 2px solid rgb(151, 1, 14);\r\n  border-radius: 8px;\r\n  font-family: \"Ysabeau SC\", sans-serif;\r\n  font-size: 1.2rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-in-out;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.backButton:hover {\r\n  background-color: rgb(151, 1, 14);\r\n  color: white;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.contentContainer {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n}\r\n\r\n.content {\r\n  background: white;\r\n  padding: 2rem;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .pageContainer {\r\n    padding: 140px 10px 20px;\r\n  }\r\n\r\n  .backButton {\r\n    position: fixed;\r\n    top: 70px;\r\n    left: 10px;\r\n    font-size: 1rem;\r\n    padding: 0.6rem 1rem;\r\n  }\r\n\r\n  .contentContainer {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .content {\r\n    padding: 1rem;\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `CommonStyles_pageContainer__oPCAy`,
	"backButton": `CommonStyles_backButton__cexXL`,
	"contentContainer": `CommonStyles_contentContainer__-wR5E`,
	"content": `CommonStyles_content__IOw17`
};
export default ___CSS_LOADER_EXPORT___;
